(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-category-games-standalone/assets/javascripts/root-momang.js') >= 0) return;  svs.modules.push('/components/casino-react/page-category-games-standalone/assets/javascripts/root-momang.js');

'use strict';

const {
  CategoriesMenu,
  PageCategoryGamesStandalone
} = svs.components.casino_react.pageCategoryGamesStandalone;
const {
  BrowserRouter,
  Switch,
  Route
} = ReactRouterDOM;
const {
  Provider
} = ReactRedux;
const {
  WidgetArea
} = svs.components.lbUtils.widgetArea;
const {
  store
} = svs.components.casino_react.casinoStore;

function Root(_ref) {
  let {
    isLiveCasino,
    initialCategory,
    currentCategoryList,
    basename
  } = _ref;
  return React.createElement("div", {
    className: "momang-casino"
  }, React.createElement(BrowserRouter, {
    basename: basename
  }, React.createElement(Provider, {
    store: store
  }, React.createElement(CategoriesMenu, {
    categories: currentCategoryList,
    defaultCategory: initialCategory
  }), React.createElement(Switch, null, currentCategoryList.map(category => React.createElement(Route, {
    key: category.urlPath,
    path: category.urlPath
  }, React.createElement(PageCategoryGamesStandalone, {
    currentCategory: category,
    currentCategoryList: currentCategoryList,
    isLiveCasino: isLiveCasino,
    renderSubHeader: false
  }), category.selectedWidgetArea && React.createElement(WidgetArea, {
    className: "momang-categories-page-widgets-react",
    widgetArea: category.selectedWidgetArea
  }))), React.createElement(Route, null, React.createElement(PageCategoryGamesStandalone, {
    currentCategory: initialCategory,
    currentCategoryList: currentCategoryList,
    isLiveCasino: isLiveCasino,
    renderSubHeader: false
  }), initialCategory.widgetArea && React.createElement(WidgetArea, {
    className: "momang-categories-page-widgets-react",
    widgetArea: initialCategory.widgetArea
  }))))));
}
setGlobal('svs.components.casino_react.pageCategoryGamesStandalone.RootMomang', Root);

 })(window);